// extracted by mini-css-extract-plugin
export default {"NotFoundPage":"NotFoundPage_NotFoundPage__K+BC5"};